import store from '@/store'
import { Message, Loading } from 'element-ui'
import axios from 'axios'

export default {
  install (Vue) {
    // 表格居中
    Vue.prototype.tableCenter = function () {
      return 'text-align: center;'
    }
    // 表头
    Vue.prototype.tableHeaderCenter = function () {
      return `
            text-align: center;
            font-size: 14px;
            font-weight:500;
            color: #333;
            background: #fafcff;
        `
    }
  }
}

/**
 *
 */
export function filterEmpyKey (data) {
  const obj = {}
  Object.keys(data).forEach(item => {
    if (data[item] !== null && data[item] !== '' && typeof (data[item]) !== 'undefined' && !obj[item]) {
      obj[item] = data[item]
    }
  })
  return obj
}

export function exportFiles (api, searchForm) {
  const loading = Loading.service({
    lock: true,
    text: '下载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  axios.get(api, {
    params: filterEmpyKey(searchForm),
    responseType: 'blob',
    headers: {
      token: store.state.token
    }
  }).then(res => {
    const result = res.data
    const head = res.headers['content-disposition']
    let fname = ''
    if (head) {
      try {
        const info = head.split(';')
        info.forEach(item => {
          if (item.indexOf('filename') >= 0) {
            fname = item.split('=')[1]
            const reg = new RegExp('"', 'g')
            fname = fname.replace(reg, '')
            // 终止循环
            throw new Error('break')
          }
        })
      } catch (err) {}
    }
    if (fname !== '') {
      const blob = new Blob([result])
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fname) // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href)
    } else {
      Message({ type: 'error', message: '数据异常，请重试' })
    }
  }).catch(e => {
    Message({ type: 'error', message: '导出异常，请重试' })
  }).finally(() => {
    loading.close()
  })
  // const form = filterEmpyKey(searchForm)
  // const token = store.state?.token
  // let str = ''
  // for (var key in form) {
  //   str += key + '=' + (form[key] || '') + '&'
  // }
  // str = str.substr(0, str.length - 1)
  // const url = `${api}?token=${token}`
  // window.location.href = url + (str ? '&' + str : str)
}

export function uploadValidate (file) {
  console.log(file)
  const suffix = file.name.substr(file.name.lastIndexOf('.') + 1)
  if (!['jpg', 'png', 'jpeg', 'gif', 'txt', 'mp4', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'rar', 'pdf', 'mp3', 'zip'].includes(suffix)) {
    Message.warning('请上传jpg/png/jpeg/gif/txt/mp4/mp3/doc/docx/xls/xlsx/ppt/pptx/rar/pdf/zip格式的文件')
    return false
  } else {
    return true
  }
}

export function uploadValidateImg (file) {
  const suffix = file.name.substr(file.name.lastIndexOf('.') + 1)
  if (!['jpg', 'png', 'jpeg', 'gif'].includes(suffix)) {
    Message.warning('请上传jpg/png/jpeg/gif格式的图片')
    return false
  } else {
    return true
  }
}

export function uploadValidateVideo (file) {
  const size = (file.size / 1024 / 1024) < 300
  const suffix = file.name.substr(file.name.lastIndexOf('.') + 1)

  if (!['mp4', 'flv'].includes(suffix) || !size) {
    Message.warning('只能上传mp4/flv文件，且不超过300M')
    return false
  } else {
    return true
  }
}

export function downloadExcelFile (data, fileName) {
  const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const downloadElement = document.createElement('a')
  // 创建下载的链接
  const href = window.URL.createObjectURL(blob)
  downloadElement.href = href
  // 下载后文件名
  downloadElement.download = decodeURIComponent(fileName)
  document.body.appendChild(downloadElement)
  downloadElement.click()
  document.body.removeChild(downloadElement)
  // 释放掉blob对象
  window.URL.revokeObjectURL(href)
}
